import { inject, Injectable } from "@angular/core";

import { catchError, concatMap, map, tap } from "rxjs/operators";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";

import { ApiInspectionService } from "@core/api";
import { ToastService } from "@core/services";

import * as InspectionsAction from "./inspections.actions";

@Injectable()
export class InspectionsEffects {
  private actions$ = inject(Actions);
  private apiInspectionSrv = inject(ApiInspectionService);
  private toastSrv = inject(ToastService);

  loadInspections$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InspectionsAction.loadInspections),
      concatMap(
        (action) => {
          return this.apiInspectionSrv.getInspectionsList(action.data).pipe(
            tap(_res => InspectionsAction.setLoadingListStatus({ loading: false })),
            tap((res) => {
              res.count > 0
                ? this.toastSrv.success('Records loaded successfully')
                : this.toastSrv.info('No records found!');
            }),
            map((res) => {
              return InspectionsAction.loadInspectionsSuccess(res);
            }),
            catchError(error => {
              return of(InspectionsAction.loadInspectionsFailure({ error }));
            })
          );
        }
      ),
    )
  );
}
